import {SupplierLocationMappingListItem} from '../../../integrated-client/models/';

interface ITableData {
  records: Array<SupplierLocationMappingListItem>
}

export class TableData implements ITableData{
  records: Array<SupplierLocationMappingListItem>

  constructor() {
    this.records = [];
  }

}
